
// @ts-nocheck
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import { RiErrorWarningFill } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import useSubmitOperation, {
  getMutationFunction,
  handleFormSubmission,
  mergeAllDataIntoFormData,
  usePrepareGraphQLVariables,
} from "../../../../CommonFunction/CustomUseFormSubmission";
import { replaceUnderscore } from "../../../../CommonFunction/common";
import {
  CREATE_USER_PAYMENT_TERMS_MANAGEMENT,
  DELETE_USER_PAYMENT_TERMS_MANAGEMENT,
  EDIT_USER_PAYMENT_TERMS_MANAGEMENT,
  PaymentTermsData,
  USER_PAYMENTS_TERMS_GETBYID,
} from "../../../../Utils/AllPagesQuriesAndMutations";
import PortalFooter from "../../../Components/Reactportal/PortalFooter";
import Reactportal from "../../../Components/Reactportal/Reactportal";
import useConcatenatedString from "../../../custom_hooks/useConcatenatedString";
import Button from "../../Button/Button";
import { FormInputSectionComponent } from "../../FormInputSectionComponent/FormInputSectionComponent";
import { ErrorToast } from "../../ToastComponent/RectHotToast";
import "./AddUserPaymentTerms.scss";
import { UserPaymentTermsManagementFields } from "./AddUserPaymentTermsManagement.Config";
import ShowUserPaymentIDS from "./PaymentTermsIDS";

const AddUserPaymentTermsManagement = ({
  fielddata,
  show,
  id,
  TypeOfPortal,
  submitType,
  ParentPortalCloseFunction,
}) => {
  const modifiedTypeOfPortal = useConcatenatedString(TypeOfPortal, "User Payment Terms");
  const [toggle, settoggle] = useState(show ? show : false);
  const [alldata, setalldata] = useState({});
  const [selectedRows, setSelectedRows] = useState([]);
  const [allFieldsData, setAllFieldsData] = useState({});
  const [showUserIDS, setShowUserIDS] = useState(false);
  const SelectedPaymentTermsIDS = useSelector((store: any) => store?.FormFieldData?.MultiSelectedRows);
  const [IDS, SetIDS] = useState([]);
  const { data } = useQuery(PaymentTermsData, {
    fetchPolicy: "network-only",
  });
  const [GetUserPaymentById] = useLazyQuery(USER_PAYMENTS_TERMS_GETBYID, {
    fetchPolicy: "network-only",
  });
  const [CreatingData, { loading: UserTermsManagement }] = useMutation(CREATE_USER_PAYMENT_TERMS_MANAGEMENT);
  const [EditingData, { loading: EditUserTerms }] = useMutation(EDIT_USER_PAYMENT_TERMS_MANAGEMENT);
  const [DeletingData, { loading: DeleteUserTerms }] = useMutation(DELETE_USER_PAYMENT_TERMS_MANAGEMENT);
  const FormData = useSelector((store: any) => store.FormFieldData);
  const dispatch = useDispatch();
  const isLoading = UserTermsManagement || EditUserTerms || DeleteUserTerms ? true : false;

  useEffect(() => {
    setalldata(FormData.fielddata);

    setSelectedRows(FormData.selectedRows);
  }, [FormData]);

  useEffect(() => {
    if (TypeOfPortal !== "Add") {
      GetUserPaymentById({
        variables: {
          id: fielddata?._id,
        },
      }).then(({ data }) => {
        let UserPaymentTermsData = {
          ...data?.VehicleCategoryMasters_WithPopulateIds[0],
        };
        // dispatch({
        //   type: "SearchMasterData",
        //   payload: {
        //     Vehicle_Type: { _id: UserPaymentTermsData?.Vehicle_Type?._id },
        //   },
        // });
        // UserPaymentTermsData.Vehicle_Type = UserPaymentTermsData?.Vehicle_Type?.Vehicle_Type;
        setAllFieldsData(UserPaymentTermsData);
      });
    } else {
      setAllFieldsData({});
    }
  }, [fielddata]);

  useEffect(() => {
    if (show === true) {
      settoggle(true);
    }
  }, [show]);
  useEffect(() => {
    let PaymentTermsMasterData = data?.EMTPaymentTermsMasters.map((item, index) => {
      return {
        Name: item?.Name,
        id: item?._id,
      };
    });
    SetIDS(PaymentTermsMasterData);
  }, [data]);

  let GetData = SelectedPaymentTermsIDS?.New?.map((item) => {
    return item.id;
  });

  // This code snippet dynamically manages CRUD (Create, Read, Update, Delete) for Brief Understanding Refer MD Documentation in FormComponents,
  const { executeOperation } = useSubmitOperation();
  const operationType = TypeOfPortal;
  let formData = mergeAllDataIntoFormData(alldata);
  const variables = usePrepareGraphQLVariables(operationType, allFieldsData, formData, selectedRows);
  const BranchMutations = {
    CreatingData,
    EditingData,
    DeletingData,
  };
  const PageName = "User Payment Terms";
  const submit = async (closeAction: string) => {
    formData.Payment_Terms_Master_Id = GetData;
    formData.UserId = FormData?.masterData?.UserId?._id;
    const mutationFunction = getMutationFunction(operationType, BranchMutations);
    const executeOperationFunction = () =>
      executeOperation({
        operationType,
        data: formData,
        selectedRows,
        Mutation: () => mutationFunction({ variables }),
        processDataBeforeSubmit: (data: any) => data,
        EditRefresh: false,
        PageName,
      });
    handleFormSubmission(executeOperationFunction, {
      operationType,
      closeAction,
      closeFormFunction: Closeformfunction,
      resetFormDataFunction: setAllFieldsData,
      onSuccess: () => {},
      onError: (error: any) => {
        ErrorToast((error as Error).message);
      },
    });
  };

  const Closeformfunction = () => {
    ParentPortalCloseFunction();
    settoggle(false);
    dispatch({ type: "ClearData", payload: { data: {} } });
  };
  const SaveAndClose = () => {
    submit("Close");
    Closeformfunction();
  };

  const handleAddCompaniesBranches = () => {
    setShowUserIDS(true);
  };
  if (TypeOfPortal === "Delete User Payment Terms" || modifiedTypeOfPortal === "Delete User Payment Terms") {
    return (
      <Reactportal
        open={toggle}
        onClose={() => settoggle(false)}
        TypeOfPortal={"Confirm"}
        //id={allFieldsData && allFieldsData?.id ? allFieldsData.id : id}
      >
        <div className="warning">
          <RiErrorWarningFill className="warningIcon" />
          <p className="warningMsg">Are You Sure You Want to Delete this Record?</p>
        </div>

        <PortalFooter
          renderContent={() => <></>}
          disabled={false}
          submitform={submit}
          submitType={"Confirm Delete"}
          handleformclose={() => {
            settoggle(!toggle);
          }}
          loadingState={isLoading}
        />
      </Reactportal>
    );
  }
  return (
    <>
      <div>
        <Reactportal
          open={toggle}
          onClose={Closeformfunction}
          TypeOfPortal={modifiedTypeOfPortal}
          //id={allFieldsData && allFieldsData?.id ? allFieldsData.id : id}
        >
          <>
            <div>
              {showUserIDS && (
                <ShowUserPaymentIDS
                  ShowData={allFieldsData}
                  getUserPaymentManagementWithIdId={IDS}
                  show={showUserIDS}
                  ClosePaymentTermsIDS={() => setShowUserIDS(false)}
                />
              )}
            </div>
            <div className="UserPaymentTerms">
              <div className="formContainer">
                {UserPaymentTermsManagementFields.map((e, i) => {
                  return (
                    <div key={e.id} className="FormSectionParent">
                      <div className="sectionHeadings">{replaceUnderscore(e.name)}</div>
                      <div className="FormSection insidecontainer">
                        <FormInputSectionComponent
                          accountId=""
                          inputfields={e.fields}
                          Type={e.name}
                          fielddata={allFieldsData}
                        />
                      </div>
                    </div>
                  );
                })}
              </div>
              <Button children={""} action={handleAddCompaniesBranches} text={"ShowIDS"} name={"ShowIDS"} />
            </div>
            <PortalFooter
              renderContent={() => <></>}
              disabled={false}
              submitform={submit}
              submitType={submitType}
              SaveAndClose={SaveAndClose}
              handleformclose={() => {
                Closeformfunction();
                settoggle(!toggle);
              }}
              loadingState={isLoading}
            />
          </>
        </Reactportal>
      </div>
    </>
  );
};

export default AddUserPaymentTermsManagement;
